<template>
  <el-container class="home-container">
    <el-header>
      <div>
        <img src="../../assets/img/cebsb_logo.png" alt="" />
        <span>汉英ERP管理系统</span>
      </div>
      <div>
        <!-- <el-button type="text" @click="workTable">工作台</el-button> -->
        <el-dropdown @command="handleCommand">
          <span class="username" style="color: white"
            >{{userJobInfo.name}}
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="changeRole">切换身份</el-dropdown-item>
            <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-aside :width="menuCollapse ? '64px' : '200px'">
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <el-menu
          ref="menuRef"
          background-color="#333744"
          text-color="#fff"
          active-text-color="#409Bff"
          unique-opened
          :collapse="menuCollapse"
          :collapse-transition="false"
          router
          @open="menuOpen"
        >
          <!-- 一级菜单 -->
          <template v-for="item in subMenuList">
            <el-submenu
              v-if="item.childMenu && item.childMenu.length"
              :index="item.id"
              :key="item.id"
            >
              <template slot="title"
                ><i :class="getIcon(item)"></i
                ><span>{{ item.name }}</span></template
              >
              <!-- 二级菜单 -->
              <template v-for="itemChild in item.childMenu">
                <el-submenu
                  v-if="
                    itemChild.childMenu && itemChild.childMenu.length
                  "
                  :index="itemChild.id"
                  :key="itemChild.id"
                >
                  <template slot="title"
                    ><span>{{ itemChild.name }}</span></template
                  >

                  <!-- 三级菜单 -->
                  <el-menu-item
                    v-for="itemChild_Child in itemChild.childMenu"
                    :index="itemChild_Child.linkUrl"
                    :key="itemChild_Child.linkUrl"
                  >
                    <span slot="title">{{
                      itemChild_Child.name
                    }}</span></el-menu-item
                  >
                </el-submenu>

                <el-menu-item
                  v-else
                  :index="itemChild.linkUrl"
                  :key="itemChild.linkUrl"
                  ><span slot="title">{{
                    itemChild.name
                  }}</span></el-menu-item
                >
              </template>
            </el-submenu>

            <el-menu-item v-else :index="item.linkUrl" :key="item.linkUrl"
              ><i :class="getIcon(item)"></i
              ><span slot="title">{{ item.name }}</span></el-menu-item
            >
          </template>
        </el-menu>
      </el-aside>
      <el-main>
        <div style="min-width: 1180px;height: 100%;">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
      </el-main>
    </el-container>
    <!-- 选择用户的Dialog -->
    <el-dialog
      title="选择身份"
      :visible.sync="selectUserDialogViaible"
      width="50%"
    >
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="roleList"
        border
        stripe
      >
        <el-table-column label="部门" prop="deptName"></el-table-column>
        <el-table-column label="角色" prop="rname"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="userLogin(scope.row)"
              >登录</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-container>
</template>

<script>
import { listByLogin, setIdentity } from '@/http/api'
export default {
  data () {
    return {
      iconsObj: {
        b_data_management: 'el-icon-school',
        c_data_management: 'el-icon-user',
        product_management_home: 'el-icon-document',
        academic_management: 'el-icon-dish',
        race_management: 'el-icon-collection',
        exam_management: 'el-icon-help',
        system_management: 'el-icon-setting',
        overseas_affairs_management: 'el-icon-ship'
      },
      username: window.sessionStorage.getItem('username'),
      roleWildcard: window.sessionStorage.getItem('roleWildcard'),
      deptWildcard: window.sessionStorage.getItem('deptWildcard'),
      isFirstLogin: window.sessionStorage.getItem('isFirstLogin'),
      subMenuList: [
        // {
        //   menu_name: '赛务管理',
        //   path: '/home',
        //   menu_id: 'f_01',
        //   childMenuList: [
        //     { menu_name: '个人赛赛务管理', menu_id: 'f_01_01', path: '/raceManagement/individual_management/individual_manage_homeview/individual_race_management' },
        //     { menu_name: '团体赛赛务管理', menu_id: 'f_01_02', path: '/raceManagement/team_management/team_race_management' }]
        // },
        // {
        //   menu_name: '考务管理',
        //   path: '/home',
        //   menu_id: 'g_01',
        //   childMenuList: [
        //     { menu_name: '个人赛考务管理', menu_id: 'g_01_01', path: '/examination_Management/individual_examination_management/examination_home_manage/examination_home_manage' },
        //     { menu_name: '团体赛考务管理', menu_id: 'g_01_02', path: '/examination_Management/team_examination_management/examination_teamhome_manage' }]
        // },
        // // {
        // //   menu_name: '系统数据管理',
        // //   path: '/home',
        // //   menu_id: 'a_01',
        // //   childMenuList: [
        // //     { menu_name: '系统学校信息', menu_id: 'a_01_01', path: '/system_data_Management/system_school_infomation' },
        // //     { menu_name: '赛区信息管理', menu_id: 'a_01_02', path: '/system_data_Management/system_competition_management' }
        // //   ]
        // // },
        // {
        //   menu_name: 'B端数据管理',
        //   path: '/b_data_Management/b_data_management',
        //   menu_id: 'b_01'
        //   // childMenuList: [
        //   //   // { menu_name: '赛区信息管理', menu_id: 'b_02_01', path: '/b_data_Management/b_division_management' },
        //   //   { menu_name: '信息管理首页', menu_id: 'b_02_01', path: '/b_data_Management/b_data_management' },
        //   //   { menu_name: '学校信息管理', menu_id: 'b_02_03', path: '/b_data_Management/b_school_management' }
        //   //   // { menu_name: '赛点信息管理', menu_id: 'b_02_04', path: '/b_data_Management/b_matchpoint_management' }
        //   // ]
        // },
        // {
        //   menu_name: 'C端数据管理',
        //   path: '/c_data_Management/c_data_management_home',
        //   menu_id: 'c_01'
        //   // childMenuList: [
        //   //   { menu_name: 'C端数据管理首页', menu_id: 'c_01', path: '/c_data_Management/c_data_management_home' },
        //   //   { menu_name: '注册信息管理', menu_id: 'c_01_01', path: '/c_data_Management/c_player_registInfo' }
        //   //   // { menu_name: '教师信息管理', menu_id: 'c_01_03', path: '/c_data_Management/c_player_teacherinfo' }
        //   // ]
        // },
        // {
        //   menu_name: '产品管理',
        //   path: '/product_Management/product_management_home',
        //   menu_id: 'd_01'
        //   // childMenuList: [
        //   //   { menu_name: '产品订单管理', menu_id: 'd_01_01', path: '/product_Management/product_management' },
        //   //   { menu_name: '字库订单管理', menu_id: 'd_01_03', path: '/product_Management/thesaurus_management' },
        //   //   {
        //   //     menu_name: '课程订单管理',
        //   //     menu_id: 'd_01_05',
        //   //     path: '/home',
        //   //     childMenuList: [
        //   //       { menu_name: '学校课程管理', menu_id: 'd_02_01', path: '/product_Management/course_schoolorder_management' },
        //   //       { menu_name: '教师课程管理', menu_id: 'd_02_02', path: '/product_Management/course_teacherorder_management' }
        //   //     ]
        //   //   },
        //   //   { menu_name: '兑换码管理', menu_id: 'd_01_04', path: '/product_Management/productcode_management' }
        //   // ]
        // },
        // {
        //   menu_name: '学术系统',
        //   path: '/academic_Management/rh',
        //   menu_id: 'e_01'
        //   // childMenuList: [
        //   //   { menu_name: '字库管理', menu_id: 'e_04_01', path: '/academic_Management/academic_font_management/academic_font_management_home' },
        //   //   { menu_name: '课程管理', menu_id: 'e_04_02', path: '/academic_Management/academic_course_management/academic_course_management' },
        //   //   { menu_name: '裁判系统', menu_id: 'e_04_03', path: '/academic_Management/rm' }
        //   // ]
        // },
        // {
        //   menu_name: '系统管理',
        //   path: '/system/home',
        //   menu_id: 'h_01'
        //   // childMenuList: [
        //   //   { menu_name: '用户管理', menu_id: 'h_04_01', path: '/system/account' },
        //   //   { menu_name: '字典管理', menu_id: 'h_04_02', path: '/system/dict' }
        //   // ]
        // }
      ],
      menuCollapse: false,
      menuOpenIndex: '',
      selectUserDialogViaible: false,
      roleList: []
    }
  },
  created () {
    // this.getMenuList()
    this.navActivePath = window.sessionStorage.getItem('navActivePath')
    this.subMenuList = this.$store.state.menuList
    this.userJobInfo = this.$store.state.userJobInfo
    console.log(this.userJobInfo)
    // 暂时去掉登陆直接显示工作台页面
    // if (this.isFirstLogin === 'true') {
    //   this.workTable()
    // }
  },
  methods: {
    async getMenuList () {
      const { data: res } = await this.$http.get('/erp/RightsManager/getMenus')
      console.log('getMenuList:', res)
      if (res.code !== 0) {
        this.$message.error(res.msg)
      }
      this.menuList = res.data
    },
    toggleCollapse () {
      this.menuCollapse = !this.menuCollapse
    },
    // 菜单图标获取，支持路径/代码的多重匹配，未匹配则按海外/默认回退
    getIcon (item) {
      const code = item.code || item.menu_code
      const link = item.linkUrl || item.path || ''
      const normalizedLink = link.replace(/\//g, '')
      const overseasIcon = 'el-icon-ship'
      const defaultIcon = 'el-icon-menu'
      return (
        this.iconsObj[code] ||
        this.iconsObj[link] ||
        this.iconsObj[normalizedLink] ||
        (link.includes('overseas') ? overseasIcon : defaultIcon)
      )
    },
    saveNavActivePath (navActivePath) {
      console.log(navActivePath)
      window.sessionStorage.setItem('navActivePath', navActivePath)
      this.navActivePath = navActivePath
    },
    workTable () {
      window.sessionStorage.setItem('isFirstLogin', false)
      if (this.navActivePath === '') {
        this.$refs.menuRef.close(this.menuOpenIndex)
        this.navActivePath = ''
        window.sessionStorage.setItem('navActivePath', '')
      }
      switch (this.roleWildcard) {
        case 'A2':
          this.$router.push('/workTable/a2')
          break
        case 'A1':
          this.$router.push('/workTable/a1')
          break
        case 'B1':
          switch (this.deptWildcard) {
            case 'sspcn':
              this.$router.push('/workTable/b1Sspcn')
              break
            case 'baby':
              this.$router.push('/workTable/b1Baby')
              break
            case 'itso':
              this.$router.push('/workTable/b1Itso')
              break
          }
          break
      }
    },
    menuOpen (value) {
      this.menuOpenIndex = value
    },
    handleCommand (command) {
      switch (command) {
        case 'logOut':
          window.sessionStorage.clear()
          this.$router.push('/login')
          break
        case 'changeRole':
          this.getUserRoleList()
          break
      }
    },
    getUserRoleList () {
      listByLogin().then((res) => {
        this.roleList = res.data
        this.selectUserDialogViaible = true
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 选择身份后登录
    userLogin (erpUserData) {
      setIdentity({ id: erpUserData.id }).then((res) => {
        console.log('loginres', res)
        this.$store.commit('SET_JOBINFO', erpUserData)
        this.$store.commit('SET_PERMISSION', res.data.roleMenus)
        this.$store.commit('SET_MENULIST', res.data.directoryMenus)
        this.$router.push('/home')
        this.$router.go(0) // 刷新页面
      }).catch((err) => {
        console.log('返回的err', err)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.home-container {
  height: 100%;

  .el-header {
    background-color: #373d41;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    font-size: 20px;
    > div {
      display: flex;
      align-items: center;
      img {
        height: 60px;
      }
      .username {
        font-size: 16px;
        margin-right: 15px;
      }
      span {
        padding-left: 15px;
      }
    }
  }

  .el-aside {
    background-color: #333744;

    .toggle-button {
      background-color: #4a5064;
      font-size: 10px;
      line-height: 24px;
      color: #fff;
      text-align: center;
      letter-spacing: 0.2em;
      cursor: pointer;
    }

    .el-menu {
      border-right: none;
    }

    .iconfont {
      margin-right: 10px;
    }
  }

  .el-main {
    background-color: #eaedf1;
    height: calc(100vh - 60px);
  }
}
</style>
